import { v4 as uuid } from 'uuid'
import { ColumnDataType } from '@global/types'

/* eslint no-useless-constructor: "off" */
/* eslint @typescript-eslint/no-inferrable-types: "off" */

const DEFAULT_FILTERS = []
const DEFAULT_SORT_ORDER: string = ''
const DEFAULT_SEARCH = ''

export interface IColumnQueryOptions {
  filters: typeof DEFAULT_FILTERS
  sortOrder: typeof DEFAULT_SORT_ORDER
  columnDataType: ColumnDataType | null
}

export class ColumnQueryOptions implements IColumnQueryOptions {
  filters: typeof DEFAULT_FILTERS

  sortOrder: typeof DEFAULT_SORT_ORDER

  searchTerm: typeof DEFAULT_SEARCH

  columnDataType: null

  constructor(
    filters: typeof DEFAULT_FILTERS = DEFAULT_FILTERS,
    sortOrder: typeof DEFAULT_SORT_ORDER = DEFAULT_SORT_ORDER,
    searchTerm: typeof DEFAULT_SEARCH = DEFAULT_SEARCH,
    columnDataType: null = null,
  ) {
    this.filters = filters
    this.sortOrder = sortOrder
    this.searchTerm = searchTerm
    this.columnDataType = columnDataType
  }
}

interface IQueryOptionFilter {
  id: string
  fieldId: string
  operator: string
  value: string | object[]
}

export class QueryOptionFilter implements IQueryOptionFilter {
  id: string

  fieldId: string

  operator: string

  value: string | object[]

  constructor(fieldId = '', operator = '', value = '') {
    this.id = uuid() // Initialize the 'id' property in the constructor
    this.fieldId = fieldId
    this.operator = operator
    this.value = value
  }
}
